import React from 'react'
import { addUnitForValue } from './utils'

import Card from '../card'

const Box = ({
  inLayout,
  clsPrefix = 'tntd-page',
  children,
  noPadding = false,
  headerHeight,
  bordered = false,
  bodyStyle = {},
  headStyle = {},
  height,
  size = 'small',
  contentTotalMargin = '0px',
  ...restProps
}) => {
  let cardTitleHeight = 0

  if (restProps.title) {
    // 根据Card的size,计算Card的title的高度值
    cardTitleHeight = size === 'small' ? 40 : 60
    // 如果Card的自定义高度，Card的title就使用此高度
    if (headStyle.hasOwnProperty(height)) {
      cardTitleHeight = headStyle.height
    }
  }

  // 如果设置了noPadding，优先级最高
  if (noPadding) {
    bodyStyle.padding = 0
    headStyle.padding = 0
  }

  // 如果传入只有数字，需要默认加px
  cardTitleHeight = addUnitForValue(cardTitleHeight)

  const cardBodyHeight = `calc(${height} - ${headerHeight} - ${contentTotalMargin} - ${cardTitleHeight})`

  return (
    <Card
      className={`${clsPrefix}-box-card`}
      bordered={bordered}
      bodyStyle={{
        ...bodyStyle,
        // overflow: 'auto',
        height: inLayout ? `calc(100% - ${headerHeight})` : cardBodyHeight,
      }}
      size={size}
      headStyle={headStyle}
      {...restProps}
    >
      {children}
    </Card>
  )
}

export default Box
